import { render, staticRenderFns } from "./master.vue?vue&type=template&id=ef887522&scoped=true&"
import script from "./master.vue?vue&type=script&lang=js&"
export * from "./master.vue?vue&type=script&lang=js&"
import style0 from "./master.vue?vue&type=style&index=0&id=ef887522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef887522",
  null
  
)

export default component.exports